import { render, staticRenderFns } from "./row-inputs-new.vue?vue&type=template&id=4a4b6cca&scoped=true&"
import script from "./row-inputs-new.vue?vue&type=script&lang=ts&"
export * from "./row-inputs-new.vue?vue&type=script&lang=ts&"
import style0 from "./row-inputs-new.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./row-inputs-new.vue?vue&type=style&index=1&id=4a4b6cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b6cca",
  null
  
)

export default component.exports